import { render } from "./staff-base-form.vue?vue&type=template&id=023752f0&ts=true"
import script from "./staff-base-form.vue?vue&type=script&lang=ts"
export * from "./staff-base-form.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__